import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './dish-details.scss';


export function DishDetailsCounter(props) {
    const { portion } = props;

    const counterContainerClasses = classNames({
        'ny__details-image__counter-container': true,
        visible: portion > 0,
    });

    return (
        <div styleName={counterContainerClasses}>
            <p styleName="ny__details-image__counter-text">
                {portion}
            </p>
        </div>
    );
}

DishDetailsCounter.propTypes = {
    portion: PropTypes.number.isRequired,
};
